module.exports = __webpack_public_path__ + "media/public/fonts/QanelasThin/QanelasThin-1e1ea2517dd5e169ad2e0fe663c93012.otf";